// extracted by mini-css-extract-plugin
export default {"blogCard":"Card_blogCard__PqAtE","blogCardImage":"Card_blogCardImage__HsKnO","readMore":"Card_readMore__fyb0p"};